// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Envelope_Filled_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21 4.5H3a.75.75 0 0 0-.75.75V18a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25A.75.75 0 0 0 21 4.5ZM20.25 18H3.75V6.955l7.743 7.098a.75.75 0 0 0 1.014 0l7.743-7.098V18Z',
  viewBox: '0 0 24 24',
  glyph: 'Envelope_Filled_Stroke2_Corner0_Rounded',
})

export const Envelope_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21 4.5H3a.75.75 0 0 0-.75.75V18a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25A.75.75 0 0 0 21 4.5Zm-9 7.983L4.928 6h14.144ZM9.254 12 3.75 17.045V6.955Zm1.11 1.017 1.125 1.036a.75.75 0 0 0 1.014 0l1.125-1.036L19.066 18H4.928ZM14.746 12l5.504-5.046v10.092Z',
  viewBox: '0 0 24 24',
  glyph: 'Envelope_Stroke2_Corner0_Rounded',
})

export const Envelope_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M21 4.5H3a.75.75 0 0 0-.75.75V18a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25A.75.75 0 0 0 21 4.5Zm-9 7.983L4.928 6h14.144ZM9.254 12 3.75 17.045V6.955Zm1.11 1.017 1.125 1.036a.75.75 0 0 0 1.014 0l1.125-1.036L19.066 18H4.928ZM14.746 12l5.504-5.046v10.092Z',
  viewBox: '0 0 24 24',
  glyph: 'Envelope_Stroke2_Corner2_Rounded',
})

export const EnvelopeNotification_Filled_Corner2_Rounded = createSinglePathSVG({
  path: 'M21 4.5H3a.75.75 0 0 0-.75.75V18a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25A.75.75 0 0 0 21 4.5ZM20.25 18H3.75V6.955l7.743 7.098a.75.75 0 0 0 1.014 0l7.743-7.098V18Z',
  viewBox: '0 0 24 24',
  glyph: 'EnvelopeNotification_Filled_Corner2_Rounded',
})

export const EnvelopeOpen_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm21.416 8.376-9-6a.75.75 0 0 0-.832 0l-9 6A.75.75 0 0 0 2.25 9v9.75a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V9a.75.75 0 0 0-.334-.624ZM9.067 14.25 3.75 18v-7.544Zm1.535.75h2.796l5.309 3.75H5.293Zm4.33-.75 5.318-3.794V18ZM12 3.9l7.68 5.12-6.282 4.48h-2.794L4.323 9.02Z',
  viewBox: '0 0 24 24',
  glyph: 'EnvelopeOpen_Stroke2_Corner0_Rounded',
})
